import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const sessionExpired = searchParams.get('expired') === '1';

    const handleLogin = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            // Prepare URL-encoded form data
            const formData = new URLSearchParams();
            formData.append('grant_type', 'password');
            formData.append('username', username);
            formData.append('password', password);

            // Send login request with form-encoded data
            const response = await api.post('/auth/token', formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });

            const { access_token } = response.data;
            localStorage.setItem('token', access_token);

            // Fetch user data using the token
            const userResponse = await api.get('/users/me');
            const user = userResponse.data;
            localStorage.setItem('user', JSON.stringify(user));

            // Redirect based on role
            if (user.role === 'admin') {
                navigate('/admin');
            } else {
                navigate('/user');
            }
        } catch (err) {
            if (err.response?.status === 503) {
                setError('Ta instancja nie jest jeszcze skonfigurowana. Skontaktuj się z operatorem.');
            } else {
                setError('Nieprawidłowe dane logowania');
            }
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-4 py-8">
            <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full max-w-md">
                <h2 className="text-2xl font-bold text-center mb-6">Logowanie</h2>
                {error && <p className="text-red-500 text-center mb-4">{error}</p>}
                {!error && sessionExpired && (
                    <p className="text-gray-600 text-center mb-4">Sesja wygasła — zaloguj się ponownie.</p>
                )}
                <form onSubmit={handleLogin}>
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2">Nazwa użytkownika:</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg text-base"
                            autoComplete="username"
                            required
                        />
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-700 mb-2">Hasło:</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg text-base"
                            autoComplete="current-password"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="bg-softTeal text-pureWhite px-4 py-3 w-full rounded-lg hover:bg-warmOrange transition text-base font-medium"
                        disabled={loading}
                    >
                        {loading ? 'Logowanie...' : 'Zaloguj'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
